import GameGrid from './GameGrid';

export default GameGrid;
